import {
  IPincodeWeather,
  IPincodeWeatherApiDoc,
  IPincodeWeatherUpdateBody,
  IRainSettings,
} from "./interface";

export const validateRainSettings = (settings: IRainSettings): string | null => {
  const condition = settings.isRainy ? "rain" : settings.isEventActive ? "event" : null;
  if (!condition) return null;
  if (!settings.startTime || !settings.endTime) {
    return `Please set both the ${condition} start and end time.`;
  }
  if (settings.endTime <= settings.startTime) {
    return `The ${condition} end time must be after the start time.`;
  }
  return null;
};

export const mapApiDocToPincodeWeather = (doc: IPincodeWeatherApiDoc): IPincodeWeather => {
  const clinicCount = doc.clinic_id?.length ?? 0;
  return {
    pincode: doc.pincode,
    city: doc.city ?? "",
    clinic: clinicCount === 1 ? "1 clinic" : `${clinicCount} clinics`,
    latitude: doc.latitude != null ? String(doc.latitude) : "",
    longitude: doc.longitude != null ? String(doc.longitude) : "",
    isRainy: !!doc.is_raining,
    isEventActive: !!doc.is_event_active,
    startTime: doc.start_time ?? "",
    endTime: doc.end_time ?? "",
    isRainingUpdatedAt: doc.is_raining_updated_at ?? null,
    reason: doc.reason ?? "",
  };
};

export const toUpdateBody = (settings: IRainSettings): IPincodeWeatherUpdateBody => ({
  is_raining: settings.isRainy,
  is_event_active: !!settings.isEventActive,
  start_time: settings.startTime || null,
  end_time: settings.endTime || null,
  reason:settings.reason|| null,
});

